<template>
        <!-- Carousel -->
          <b-carousel
              :id="`carousel_` + jobId"
              :interval="0"
              controls
              :indicators=false
              img-width="275"
              img-height="150"
              @sliding-start="onSlideStart"
            >
            <b-carousel-slide v-for="(entity, index) in entityList" :key="index" img-blank>
              <entity-video-wrapper :entity="entity" ref="EntityVideoWrapper"  class="rounded-0"></entity-video-wrapper>
            </b-carousel-slide>
          </b-carousel>
        <!-- End carousel -->
</template>

<script>
import EntityVideoWrapper from '#/ui/Components/Entities/EntityVideoWrapper.vue';

export default {
  components: {
    EntityVideoWrapper,
  },
  data() {
    return {
      lastSlide: 0,
    }
  },
  props: {
    entityList: {
      type: Array,
      required: true,
    },
    jobId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    console.log('entityList ', this.entityList);
    console.log('jobId ', this.jobId);
  },
  methods: {
    onSlideStart(slide) {
      let index = this.lastSlide;
      this.lastSlide = slide;
      this.$refs.EntityVideoWrapper[index].setVideoPause();
    }
  },
  
};
</script>
<style>
.carousel-control-prev, .carousel-control-next {
  height: 50% !important;
  top: 25% !important;
}
.carousel-caption {
    position: absolute !important;
    top: 0% !important;
    right: 0% !important;
    bottom: 2px !important;
    left: 0% !important;
    z-index: 0 !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    color: #fff;
    text-align: center;
}
</style>